/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `CHAMPION_X` - Champion X
 * @export
 */
export const DataSurveyTypeEnum = {
    ChampionX: 'CHAMPION_X'
} as const;
export type DataSurveyTypeEnum = typeof DataSurveyTypeEnum[keyof typeof DataSurveyTypeEnum];


export function instanceOfDataSurveyTypeEnum(value: any): boolean {
    for (const key in DataSurveyTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(DataSurveyTypeEnum, key)) {
            if (DataSurveyTypeEnum[key as keyof typeof DataSurveyTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DataSurveyTypeEnumFromJSON(json: any): DataSurveyTypeEnum {
    return DataSurveyTypeEnumFromJSONTyped(json, false);
}

export function DataSurveyTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSurveyTypeEnum {
    return json as DataSurveyTypeEnum;
}

export function DataSurveyTypeEnumToJSON(value?: DataSurveyTypeEnum | null): any {
    return value as any;
}

export function DataSurveyTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DataSurveyTypeEnum {
    return value as DataSurveyTypeEnum;
}

